import { Box } from "@mui/material";
import React from "react";

const Footer = () => {
  return <Box sx={{ height: "200px", width: "100%" }}></Box>;
};

export default Footer;
